export default __webpack_public_path__ + "static/8_18-8c0411512f66a28c60cff5a256fce760.png";